import { render } from "./text-input.vue?vue&type=template&id=b5e06d24&scoped=true&bindings={\"name\":\"props\",\"modelValue\":\"props\"}"
import script from "./text-input.vue?vue&type=script&lang=js"
export * from "./text-input.vue?vue&type=script&lang=js"

import "./text-input.vue?vue&type=style&index=0&id=b5e06d24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b5e06d24"

export default script